import { AudioManager } from "../../../AudioManager";
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { ScoreContainer } from "./ScoreContainer";

export class HUD extends Phaser.GameObjects.Container {

    private scoreContainer: ScoreContainer;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT * .45;

        this.scaleY = GameVars.scaleY;

    
        this.scoreContainer = new ScoreContainer(this.scene, "texture_atlas_3");
        this.scoreContainer.y = -202;
        this.add(this.scoreContainer);
    }

    public onGameStarted(): void {

        const scoreStr = GameVars.formatNumber(GameVars.templokEngine.score);
        this.scoreContainer.updateScoreDigits(scoreStr);

        if (GameVars.resumedGame) {
            this.scoreContainer.scoreNum = GameVars.templokEngine.score;
        }
    }

    public updateScore(): void {

        this.scoreContainer.updateScore(GameVars.score);
    }

    public onCombo(n: number, comboPoints: number): void {

        const comboContainer = new Phaser.GameObjects.Container(this.scene);
        comboContainer.x = this.x;
        comboContainer.y = this.y;
        comboContainer.scaleY = GameVars.scaleY;
        this.scene.add.existing(comboContainer);

        const comboLabel = new Phaser.GameObjects.Image(this.scene, -42, 0, "texture_atlas_3", "combox");
        comboContainer.add(comboLabel);

        const comboNumberLabel = new Phaser.GameObjects.Image(this.scene, comboLabel.width / 2 + 16, 0, "texture_atlas_3", "combo_" + n);
        comboContainer.add(comboNumberLabel);

        const pointsLabel_py = 90;

        // componer la cifra de los puntos
        const thousands = Math.floor(comboPoints / 1000);
        const hundreds = Math.floor((comboPoints - thousands * 1000) / 100);
        const tens = Math.floor((comboPoints - thousands * 1000 - hundreds * 100) / 10);
        const units = comboPoints - thousands * 1000 - hundreds * 100 - tens * 10;
        
        const numbersScale = .9;

        let thousandsLabel: Phaser.GameObjects.Image;

        const hundredsLabel = new Phaser.GameObjects.Image(this.scene, -100, pointsLabel_py, "texture_atlas_3", hundreds.toString());
        hundredsLabel.setScale(numbersScale);
        comboContainer.add(hundredsLabel);

        const tensLabel = new Phaser.GameObjects.Image(this.scene, hundredsLabel.x + hundredsLabel.width * numbersScale, pointsLabel_py, "texture_atlas_3", tens.toString());
        tensLabel.setScale(numbersScale);
        comboContainer.add(tensLabel);

        const unitsLabel = new Phaser.GameObjects.Image(this.scene, tensLabel.x + tensLabel.width * numbersScale, pointsLabel_py, "texture_atlas_3", units.toString());
        unitsLabel.setScale(numbersScale);
        comboContainer.add(unitsLabel);

        let plus_px: number;
       
        if (thousands !== 0) {

            thousandsLabel = new Phaser.GameObjects.Image(this.scene, hundredsLabel.x - hundredsLabel.width * numbersScale - 10, pointsLabel_py, "texture_atlas_3", thousands.toString());
            thousandsLabel.setScale(numbersScale);
            comboContainer.add(thousandsLabel);

            const comaLabel = new Phaser.GameObjects.Image(this.scene, hundredsLabel.x - hundredsLabel.width * numbersScale + 12, pointsLabel_py + 6, "texture_atlas_3", "coma");
            comaLabel.setScale(.85);
            comboContainer.add(comaLabel);

            plus_px = thousandsLabel.x - thousandsLabel.width * numbersScale * .85;

        } else {

            plus_px = hundredsLabel.x - hundredsLabel.width * numbersScale;
        }

        const plusLabel = new Phaser.GameObjects.Image(this.scene, plus_px, pointsLabel_py, "texture_atlas_3", "plus");
        plusLabel.setOrigin(1, .5);
        plusLabel.setScale(.85);
        comboContainer.add(plusLabel);

        const pointsLabel = new Phaser.GameObjects.Image(this.scene, unitsLabel.x + unitsLabel.width * numbersScale , pointsLabel_py, "texture_atlas_3", "points");
        pointsLabel.setOrigin(0, .5);
        pointsLabel.setScale(.85);
        comboContainer.add(pointsLabel);

        this.scene.tweens.add({
            targets: comboContainer,
            scaleX: 1.25,
            scaleY: 1.25 * GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1500
        });

        this.scene.tweens.add({
            targets: comboContainer,
            alpha: 0,
            y: this.y - 50,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1000,
            onComplete: function(): void {
                comboLabel.destroy();
            },
            onCompleteScope: this,
            delay: 1650
        });

        AudioManager.playSound("combo");
    }
}
